"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function FolderTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'folder',
        theme: 'twotone',
        nameWithTheme: 'folder-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: primaryColor,
                    d: 'M880 298.4H521L403.7 186.2c-1.5-1.4-3.5-2.2-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M372.5 256H184v512h656V370.4H492.1z'
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'folder-twotone';
var FolderTwoTone = temp;
exports.default = FolderTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/twotone/FolderTwoTone.js
// module id = 1216
// module chunks = 0